export const DAYS = [
  'Понедельник', 
  'Вторник', 
  'Среда', 
  'Четверг', 
  'Пятница', 
  'Суббота', 
  'Воскресенье'
];

export const DAYS_SHORT = [
  'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'
];


export const MONTHS = [
  'января', 'февраля', 'марта',
  'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября',
  'октября', 'ноября', 'декабря'
];

export const MONTHS_SHORT = [
  'янв', 'фев', 'мар',
  'апр', 'май', 'июн',
  'июл', 'авг', 'сен',
  'окт', 'ноя', 'дек'
];